import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Navbar.css';

const Navbar = ({ darkMode, toggleDarkMode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setOpenDropdown(null);
  };

  return (
    <motion.nav
      className={`navbar ${darkMode ? 'dark' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          Suraj Kumar Sah
        </Link>
        <div className={`navbar-center ${isOpen ? 'active' : ''}`}>
          <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
            <Link to="/" className="navbar-link" onClick={closeMenu}>
              Home
            </Link>

            <div className="navbar-dropdown">
              <button className={`navbar-link dropdown-toggle ${openDropdown === 'professional' ? 'open' : ''}`} onClick={() => handleDropdown('professional')}>
                Professional <span className="dropdown-arrow">{openDropdown === 'professional' ? '🔼' : '🔽'}</span>
              </button>
              {openDropdown === 'professional' && (
                <motion.div
                  className="dropdown-menu"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                >
                  <Link to="/about" className="dropdown-item" onClick={closeMenu}>About</Link>
                  <Link to="/company" className="dropdown-item" onClick={closeMenu}>Company</Link>
                  <Link to="/skills" className="dropdown-item" onClick={closeMenu}>Skills</Link>
                  <Link to="/experience" className="dropdown-item" onClick={closeMenu}>Experience</Link>
                  <Link to="/education" className="dropdown-item" onClick={closeMenu}>Education</Link>
                </motion.div>
              )}
            </div>

            <div className="navbar-dropdown">
              <button className={`navbar-link dropdown-toggle ${openDropdown === 'portfolio' ? 'open' : ''}`} onClick={() => handleDropdown('portfolio')}>
                Portfolio <span className="dropdown-arrow">{openDropdown === 'portfolio' ? '🔼' : '🔽'}</span>
              </button>
              {openDropdown === 'portfolio' && (
                <motion.div
                  className="dropdown-menu"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                >
                  <Link to="/projects" className="dropdown-item" onClick={closeMenu}>Projects</Link>
                  <Link to="/reviews" className="dropdown-item" onClick={closeMenu}>Reviews</Link>
                  <Link to="/gallery" className="dropdown-item" onClick={closeMenu}>Gallery</Link>
                  <Link to="/blog" className="dropdown-item" onClick={closeMenu}>Blog</Link>
                </motion.div>
              )}
            </div>

            <Link to="/contact" className="navbar-link" onClick={closeMenu}>
              Contact
            </Link>
          </div>
        </div>
        <div className="navbar-controls">
          <button className="dark-mode-toggle" onClick={toggleDarkMode} aria-label="Toggle dark mode">
            {darkMode ? '☀️' : '🌙'}
          </button>
          <button className={`hamburger-menu ${isOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Toggle menu" aria-expanded={isOpen}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        {isOpen && <div className="navbar-overlay" onClick={closeMenu}></div>}
      </div>
    </motion.nav>
  );
};

export default Navbar;